import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * The server has encountered a situation it does not know how to handle.
 * HTTP Response Status Code 500
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class InternalServerError extends MfsFolderError {
    constructor(message, eventName) {
        super(message !== null && message !== void 0 ? message : `Internal Server Error`, false, eventName !== null && eventName !== void 0 ? eventName : 'InternalServerError', MfsStatusCode.UnhandledException);
    }
}
//# sourceMappingURL=internalServerError.js.map